<template>
  <el-select>
    <el-option-group
      v-for="group in countryOptions"
      :id="'InputSelect_' + fieldName"
      :key="group.label"
      :label="group.label"
      :name="fieldName"
    >
      <el-option
        :id="'InputSelect_' + item.key"
        v-for="item in group.options"
        :key="item.key"
        :label="item.label"
        :value="item.key"
        :model-value="item.key"
      >
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { countryList } from '@/utils/constants'
import BarcodeTypesMixin from '@/components/mixins/BarcodeTypesMixin.vue'

type TCountryOption = {
  key: string
  label: string
}

type TCountryGroup = {
  label: string
  options: Array<TCountryOption>
}

@Options({
  name: 'InputSelectCountry',
})
export default class InputSelectCountry extends mixins(BarcodeTypesMixin) {
  @Prop({ type: String }) readonly fieldName?: string = ''
  countryOptions: TCountryGroup[] = []

  get barcodeType() {
    return this.$store.state?.barcode?.currentSelectedBarcodeType || this.$store.state?.barcode?.barcode?.barcodeType
  }

  get countriesList() {
    return this.getBarcodeTypeInfoByType(this.barcodeType)?.countries || []
  }

  created() {
    const getOptionLabels = (o: string[]) =>
      o.map((countryKey) => ({
        key: countryKey,
        label: this.$t(`countryList.${countryKey}`),
      }))

    if (this.countriesList?.length) {
      this.countryOptions = [
        {
          label: this.$t('all countries'),
          options: getOptionLabels(this.countriesList),
        },
      ]
    } else {
      // Take the first three items as "frequently used"
      const list = [...countryList]
      const frequentlyUsed = list.splice(0, 3)

      this.countryOptions = [
        {
          label: this.$t('frequently used'),
          options: getOptionLabels(frequentlyUsed),
        },
        {
          label: this.$t('all countries'),
          options: getOptionLabels(list),
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.el-select.el-select--medium {
  width: 100%;

  .el-input--medium .el-input--suffix {
    height: 40px;
  }
}
</style>
